var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"text-xs-center pa-5"},[_vm._v("Logging you in...")])}
var staticRenderFns = []

export { render, staticRenderFns }